export const COACHMARK_IDENTIFY_BODY_LOCATION_DISMISSED =  "coachmark_identify_body_location_dismissed";